(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-nhoi-klaviyo]');
  if (!button) return;
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', button.dataset.nhoiKlaviyo]);
});

  } catch(e) { console.error(e); }
})();
})();
